import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';

export type CronTaskHealthDTO = {
  task: string;
  lastStatus: 'success' | 'failed';
  lastStartedAt: string;
  lastDurationMs: number;
  lastError?: string;
  lastSuccessAt?: string;
  runs7d: number;
  failures7d: number;
};

export type CronJobHealthDTO = {
  name: string;
  schedule?: string;
  lastRunAt?: string;
  lastFinishedAt?: string;
  nextRunAt?: string;
  lockedAt?: string;
  failReason?: string;
  isOverdue: boolean;
  isStuck: boolean;
  tasks: CronTaskHealthDTO[];
};

export type StreamGroupHealthDTO = {
  name: string;
  consumers: number;
  pending: number;
};

export type StreamMessageSampleDTO = {
  id: string;
  at?: string;
  reason?: string;
  fields: Record<string, string>;
};

export type StreamHealthDTO = {
  key: string;
  environment: string;
  name: string;
  length: number;
  groups: StreamGroupHealthDTO[];
  retryCount: number;
  deadLetterCount: number;
  deadLetterSamples: StreamMessageSampleDTO[];
  deadLetterReasons: { reason: string; count: number; isNoAudio: boolean }[];
  skippedCount: number;
  skippedSamples: StreamMessageSampleDTO[];
};

export type BullQueueHealthDTO = {
  name: string;
  waiting: number;
  active: number;
  delayed: number;
  prioritized: number;
  failed: number;
  completed: number;
  paused: number;
  recentFailures: { id: string; name?: string; reason?: string; failedAt?: string }[];
};

export type FailedEventSummaryDTO = {
  eventType: string;
  env: string;
  count: number;
  lastAt: string;
};

export type SystemHealthDTO = {
  environment: string;
  generatedAt: string;
  cronJobs: CronJobHealthDTO[];
  redis: {
    available: boolean;
    error?: string;
    streams: StreamHealthDTO[];
    bullQueues: BullQueueHealthDTO[];
  };
  failedEvents: FailedEventSummaryDTO[];
};

export const getSystemHealth: ApiDescription = {
  endpoint: '/admin/system-health',
  method: RequestsMethod.Get,
};

export type GetSystemHealth = ApiData<never, SystemHealthDTO>;

export const archiveNoAudioDeadLetters: ApiDescription = {
  endpoint: '/admin/system-health/streams/archive-no-audio',
  method: RequestsMethod.Post,
};

export type ArchiveNoAudioDeadLetters = ApiData<{ key: string }, { moved: number }>;

export const runCronTaskNow: ApiDescription = {
  endpoint: '/admin/system-health/run-task',
  method: RequestsMethod.Post,
};

export type CronTaskRunResultDTO = {
  task: string;
  status: 'success' | 'failed';
  durationMs: number;
  error?: string;
};

export type RunCronTaskNow = ApiData<{ task: string }, CronTaskRunResultDTO>;
